import { render, staticRenderFns } from "./freeze.vue?vue&type=template&id=6994923e&"
import script from "./freeze.vue?vue&type=script&lang=js&"
export * from "./freeze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports